
import Vue from 'vue';
import { TransformedLmSlider } from '~/transforms/transformModules';

export default Vue.extend({
  props: {
    data: {
      type: Object as () => TransformedLmSlider['data'],
      required: true,
    },
  },
  data() {
    return {
      transformSlides: [] as Array<any>,
      slidesLenght: 0 as number,
      flickityOptions: {
        freeScroll: true,
        contain: true,
        prevNextButtons: false,
        pageDots: true,
      },
      activeSlideIndex: 0 as number,
    };
  },

  methods: {
    next() {
      (this.$refs.flickity as any).next();
    },

    previous() {
      (this.$refs.flickity as any).previous();
    },

    checkSliderArrows(index: number) {
      const arrows = this.$refs.arrows as HTMLElement;
      if (index === this.slidesLenght - 1) {
        arrows.classList.add('lm-slider--lastItem');
      } else if (index === 0) {
        arrows.classList.add('lm-slider--firstItem');
      } else {
        arrows.classList.remove('lm-slider--firstItem');
        arrows.classList.remove('lm-slider--lastItem');
      }
    },
  },

  updated() {
    if (this.$refs.flickity) {
      setTimeout(() => {
        (this.$refs.flickity as any).resize();
        this.slidesLenght = (this.$refs.flickity as any).$children.length;
      }, 100);
      (this.$refs.flickity as any).on('change', (index: number) => {
        this.activeSlideIndex = index;
        this.checkSliderArrows(index);
      });
      (this.$refs.flickity as any).on('dragMove', () => {
        (this.$refs.sliderCt as HTMLElement).classList.add('lm-slider--dragMove');
      });
      (this.$refs.flickity as any).on('dragEnd', () => {
        (this.$refs.sliderCt as HTMLElement).classList.remove('lm-slider--dragMove');
      });
    }
  },

  mounted() {
    this.transformSlides = [...this.data.slides];
    this.transformSlides.reverse();
  },
});
